import React from "react";
import { useNavigate } from "react-router-dom";
import Joyride from "react-joyride";

const steps = [
  {
    target: '#Sidebar-Blueprint',
    content: 'Edit the sections you just created to change how we fill out your newsletter each week.',
    disableBeacon: true,
  },
  {
    target: "#walkthrough-newsletter-edition",
    content: 'Each row on this page represents an edition of your newsletter.'
  },
  {
    target: '#walkthrough-arrival-date',
    content: 'The arrival date is when our team will have the edition prepared by.',
  },
  {
    target: '#walkthrough-distribution-date',
    content: 'The distribution date is when the edition will be sent.'
  },
  {
    target: '#walkthrough-add-content',
    content: 'Add custom content to include in this edition, such as your thoughts or a quote.',
  },
  {
    target: '#walkthrough-add-links',
    content: 'Add links to include in this edition, such as blog posts and articles.',
  },
  {
    target: '#Sidebar-Sources',
    content: 'Add sources for us to regularly visit to curate content for your newsletter.',
  },
];

export interface OnboardingWalkthroughProps {
  run: boolean;
  setRun: (run: boolean) => void;
}

const OnboardingWalkthrough: React.FC<OnboardingWalkthroughProps> = ({ run, setRun }) => {
  const navigate = useNavigate();

  return (
    <Joyride
      steps={steps}
      run={run}
      continuous
      showProgress
      showSkipButton
      disableOverlayClose={true}
      styles={{
        options: {
          zIndex: 10000,
        },
        buttonNext: {
          backgroundColor: '#5D5DED',
          color: '#ffffff',
          borderRadius: "8px",
        },
        buttonBack: {
          color: '#5D5DED',
        },
        beaconInner: {
          backgroundColor: '#5D5DED',
        },
        beaconOuter: {
          backgroundColor: '#6F6FFE',
          boxShadow: '0 0 15px rgba(93, 93, 237, 0.6)',
          borderColor: '#5D5DED',
        }
      }}
      callback={data => {
        if (data.status === 'finished' || data.status === 'skipped') {
          setRun(false);
          navigate('/sources');
        }
      }}
    />
  );
};

export default OnboardingWalkthrough;
